import { render } from "./MenuDemo.vue?vue&type=template&id=dc5ccf48&scoped=true"
import script from "./MenuDemo.vue?vue&type=script&lang=js"
export * from "./MenuDemo.vue?vue&type=script&lang=js"

import "./MenuDemo.vue?vue&type=style&index=0&id=dc5ccf48&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5ccf48"]])

export default __exports__